import packageJson from "../../package.json";

const VersionDisplay = () => {
    return <span>Version {packageJson.version}</span>;
};

export default VersionDisplay;
